import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=d1dfd610&scoped=true&"
import script from "./ActiveOrders.vue?vue&type=script&lang=js&"
export * from "./ActiveOrders.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrders.vue?vue&type=style&index=0&id=d1dfd610&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dfd610",
  null
  
)

export default component.exports